import Bowser from 'bowser';
import moment from 'moment-timezone';

function analyticClient (Axios, action = null, language = 'spanish') {
  try {
    const bowser = Bowser.getParser(window.navigator.userAgent);
    const obj = {
      vendorId: localStorage.getItem('_id'),
      ip: '',
      path: window.location.pathname,
      fullPath: window.location.href,
      city: '',
      country: '',
      language: language,
      domain: window.location.hostname,
      userId: localStorage.getItem('_user') ? localStorage.getItem('_user') : null,
      browser: bowser.getBrowserName(),
      device: bowser.getPlatformType(),
      system: bowser.getOSName(),
      systemVersion: bowser.getOSVersion() === undefined ? null : bowser.getOSVersion(),
      visitDate: moment().format('YYYY-MM-DD hh:mm'),
      source: 'qr',
      date: ''
    };
    if (action != null) {
      obj.action = action;
    }
    if (language !== 'spanish') {
      obj.language = language;
    }
    Axios.post('/analytics/navigator', obj);
  } catch (e) {
    console.warn('Error', e);
  }
}

export default analyticClient;
